import styled from 'styled-components/macro';

export const OrizontalResizer = styled.div`
  flex: 0 0 auto;
  width: 12px;
  cursor: ew-resize;
  background-color: ${({ theme }) => theme.colorPalette.grey.grey4};
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before,
  &::after {
    content: '';
    display: block;
    height: 20px;
    width: 2px;
    background-color: ${({ theme }) => theme.colorPalette.white};
    position: absolute;
  }


`;

export const VerticalResizer = styled.div`
  height: 12px;
  background-color: ${({ theme }) => theme.colorPalette.grey.grey4};
  cursor: ns-resize;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before,
  &::after {
    content: '';
    display: block;
    height: 2px;
    width: 20px;
    background-color: ${({ theme }) => theme.colorPalette.white};
    position: absolute;
  }
`;
